/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const pay = process.env.NODE_ENV == "pre" ? 'Payment中金微信' : 'Payment' //正式
const routes = [
    //华为智能短信页面新版本
    // { path: '/hwwap/recharge/wappay.html', name: 'hwwap', component: resolve => require(['@/pages/product/hwwap'], resolve), meta: { title: '充值页面' } },
    { path: '/pay/hwpayment', name: 'Order', component: resolve => require([`@/pages/payment/${pay}`], resolve), meta: { title: '订单信息' } },

    //华为智能短信页面老版本
    //   { path: '/hwwap/recharge/wappay.html', name: 'hwwap1', component: resolve => require(['@/pages/product/hwwap copy'], resolve), meta: { title: '充值页面' } },
    // { path: '/pay/hwpayment', name: 'Order', component: resolve => require(['@/pages/payment/PaymentOld'], resolve), meta: { title: '订单信息' } },

    //华为智能短信仅支持电信充值页面
    //   { path: '/hwwap/ct/recharge/wappay.html', name: 'hwwapOldCT', component: resolve => require(['@/pages/product/hwwapOldCT'], resolve), meta: { title: '充值页面' } },
    //华为智能短信仅支持移动充值页面
    { path: '/hwwap/cmcc/recharge/wappay.html', name: 'hwwapOldCMCC', component: resolve => require(['@/pages/product/hwwapOldCMCC'], resolve), meta: { title: '充值页面' } },


    { path: '/next/orderlist', name: 'OrderList', component: resolve => require(['@/pages/query/OrderListCodeCheck'], resolve), meta: { title: '订单列表查询' } },//短信验证 新样式
    // { path: '/next/orderlist', name: 'OrderList', component: resolve => require(['@/pages/query/OrderListNoCheck'], resolve), meta: { title: '订单列表查询' } },//不验证直接获取 新样式
    // { path: '/next/orderlist', name: 'OrderList', component: resolve => require(['@/pages/query/OrderListOldCodeCheck'], resolve), meta: { title: '订单列表查询' } },//短信验证 老样式

    { path: '/next/order/detail', name: 'OrderDetail', component: resolve => require(['@/pages/query/OrderDetail'], resolve), meta: { title: '订单详情' } },
    { path: '/Help', name: 'Help', component: resolve => require(['@/pages/Bottom/Help'], resolve), meta: { title: '帮助' } },
    { path: '/PrivacyStatement', name: 'PrivacyStatement', component: resolve => require(['@/pages/Bottom/PrivacyStatement'], resolve), meta: { title: '隐私声明' } },
    { path: '/UserAgreement', name: 'UserAgreement', component: resolve => require(['@/pages/Bottom/UserAgreement'], resolve), meta: { title: '用户协议' } },

    { path: '/forward/flow', name: 'ForwardFlow', component: resolve => require(['@/pages/active/ForwardFlow'], resolve), meta: { title: '优惠活动办理' } },
    { path: '/feeoil', name: 'FeeOil', component: resolve => require(['@/pages/active/FeeOil'], resolve), meta: { title: '话费油礼超值购' } },
    { path: '/glfee', name: 'GLfee', component: resolve => require(['@/pages/active/GLfee'], resolve), meta: { title: '话费超值购' } },


]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_ROUTE,
    routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js